export enum issueResolutionTypes {
  none = "none",
  refundedToCustomer = "refundedToCustomer",
  acceptedAsPartial = "acceptedAsPartial",
  redirectedToInvoice = "redirectedToInvoice",
  settledToMerchantBalance = "settledToMerchantBalance",
}
